module.exports = __webpack_public_path__ + "static/media/simtislogo.4d0c7f70.png";